module.exports = __webpack_public_path__ + "static/card1-4854959d6c1afdce361f82aed1f307cc.png";